import { LocalizedTextMap } from '@dixa/messenger-api-payloads';
import {
  MessengerSettingsV2,
  MinimumIdentificationLevel,
} from 'lib-shared-legacy-types';

import { MessengerTranslatedLanguage } from 'components/settings/components/sections/dixaMessenger/views/settings/components/generalSettings/languageSettings/languages';

export type PresetBackgroundColors =
  MessengerSettingsV2['style']['theme']['background'];

export type ThemeColor = {
  background: `#${string}`;
  presentationColor: string;
  id: PresetBackgroundColors;
  title: Capitalize<PresetBackgroundColors>;
};

export type LauncherIconType = 'dixa-branded-default' | 'chat-bubbles';

export interface FormValues {
  title: LocalizedTextMap;
  description: LocalizedTextMap;
  startConversation: LocalizedTextMap;
  findArticles: LocalizedTextMap;
  backgroundColor: string;
  bulletinBoardEnabled: boolean;
  bulletinBoardId: string | null;
  availableLocales: MessengerTranslatedLanguage[];
  defaultLanguage: MessengerTranslatedLanguage;
  logo: string | undefined;
  launcherIconType: LauncherIconType;
  minimumIdentificationLevel: MinimumIdentificationLevel;
  agentDisplayNameFirstWord: boolean;
  messengerMode:
    | 'default-widget-mode' // Users can start a live conversation
    | 'form-without-conversation-widget-mode'; // Users can only submit a form (no live conversation support)
  // The contact form ID to be used in form-only mode.
  formOnlyModeContactFormId?: string;
  /**
   * The endpoint URI to which the form should be submitted. The endpoint URI
   * should be in the following format:
   * https://forms.euw1.dixa.io/v1/schematic-forms/{OrgId}/{EndpointId} The URI
   * is supposed to be parsed and the OrgId and EndpointId should be extracted
   * from it.
   */
  formOnlyModeEndpointURI?: string;
}

// This serves as a reference for field name values, it's used to ensure any update to `FormValues`
// is reflected in field names in the rest of the files.
export const messengerSettingsFormFields: ConvertKeyValueToKeyKey<FormValues> =
  {
    title: 'title',
    description: 'description',
    startConversation: 'startConversation',
    findArticles: 'findArticles',
    backgroundColor: 'backgroundColor',
    bulletinBoardEnabled: 'bulletinBoardEnabled',
    bulletinBoardId: 'bulletinBoardId',
    availableLocales: 'availableLocales',
    logo: 'logo',
    launcherIconType: 'launcherIconType',
    defaultLanguage: 'defaultLanguage',
    minimumIdentificationLevel: 'minimumIdentificationLevel',
    agentDisplayNameFirstWord: 'agentDisplayNameFirstWord',
    messengerMode: 'messengerMode',
    formOnlyModeContactFormId: 'formOnlyModeContactFormId',
    formOnlyModeEndpointURI: 'formOnlyModeEndpointURI',
  };

type ConvertKeyValueToKeyKey<T, TKey extends keyof T = keyof T> = T extends {
  [key in TKey]: T[key];
}
  ? { [key in TKey]-?: key }
  : never;
